(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Voonto"] = factory();
	else
		root["Voonto"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.exists = exports.getInstance = exports.ready = exports.LazyLoad = exports.moment = exports.Cookies = exports.RSVP = exports.RDOM = exports.R = exports.is = exports._ = exports.$ = exports.VERSION = undefined;
	
	var _package = __webpack_require__(55);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _voonto = __webpack_require__(77);
	
	var _voonto2 = _interopRequireDefault(_voonto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERSION = exports.VERSION = _package2.default.version;
	var $ = exports.$ = window.jQuery || window.$;
	var _ = exports._ = window._;
	var is = exports.is = window.is;
	var R = exports.R = window.React;
	var RDOM = exports.RDOM = window.ReactDOM;
	var RSVP = exports.RSVP = window.RSVP;
	var Cookies = exports.Cookies = window.Cookies;
	var moment = exports.moment = window.moment;
	var LazyLoad = exports.LazyLoad = window.LazyLoad;
	var ready = exports.ready = _voonto2.default.ready;
	var getInstance = exports.getInstance = _voonto2.default.getInstance;
	var exists = exports.exists = true;
	
	ready.then(function (app) {
	  return app.promised('voonto:ready', app);
	});

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PAYWALL_COOKIE = exports.VOCUSER_COOKIE = exports.SHOW_LOGS = exports.REQUIREJS_URL = exports.EVENTS_PROPERTY = exports.PROMISES_PROPERTY = exports.NAMESPACE = exports.REJECT_TIMEOUT = undefined;
	
	var _package = __webpack_require__(55);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REJECT_TIMEOUT = exports.REJECT_TIMEOUT = 15000;
	var NAMESPACE = exports.NAMESPACE = 'vocento';
	var PROMISES_PROPERTY = exports.PROMISES_PROPERTY = '__PROMISES__';
	var EVENTS_PROPERTY = exports.EVENTS_PROPERTY = '__EVENTS__'; // NOTE: unused
	var REQUIREJS_URL = exports.REQUIREJS_URL = _isPhantomJS() ? 'vendors/require.js' : '//static.vocento.com/voonto/' + _package2.default.version + '/vendors/require.js';
	var SHOW_LOGS = exports.SHOW_LOGS = document.location.search.indexOf('voonto_debug=1') > -1;
	var VOCUSER_COOKIE = exports.VOCUSER_COOKIE = 'voc_uid';
	var PAYWALL_COOKIE = exports.PAYWALL_COOKIE = 'voc_paywall';
	
	/* Private */
	
	function _isPhantomJS() {
	  return document.location.protocol === 'file:';
	}

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	module.exports = {
		"name": "voonto",
		"version": "1.1.12",
		"description": "",
		"main": "./src/index.js",
		"scripts": {
			"test": "./node_modules/.bin/mocha-phantomjs dist/spec.html --reporter xunit --file test-results.xml",
			"start": "webpack-dev-server --content-base dist/",
			"build": "./node_modules/.bin/webpack"
		},
		"author": "Iván Pérez <ivanperez@vocento.com>",
		"license": "SEE LICENSE IN LICENSE.md",
		"devDependencies": {
			"babel-core": "^6.17.0",
			"babel-loader": "^6.2.5",
			"babel-polyfill": "^6.16.0",
			"babel-preset-es2015": "^6.16.0",
			"chai": "^3.5.0",
			"html-webpack-plugin": "^2.28.0",
			"json-loader": "^0.5.4",
			"mocha": "^3.1.0",
			"mocha-loader": "^1.0.0",
			"mocha-phantomjs": "^4.1.0",
			"webpack": "^1.13.3",
			"webpack-shell-plugin": "^0.4.3"
		},
		"dependencies": {
			"is_js": "^0.9.0",
			"jquery": "^3.1.1",
			"jquery-inview": "^1.1.2",
			"jquery-lazyload": "^1.9.7",
			"js-cookie": "^2.1.4",
			"lodash": "^4.16.4",
			"moment": "^2.18.1",
			"parse-url": "^1.3.7",
			"react": "^15.5.4",
			"react-dom": "^15.5.4",
			"react-lite": "^0.15.34",
			"rsvp": "^3.5.0",
			"vanilla-lazyload": "^8.0.3"
		}
	};

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(54);
	
	var _window = window,
	    $ = _window.$,
	    RSVP = _window.RSVP;
	
	
	var Voonto = Object.preventExtensions({
	  getInstance: function getInstance() {
	    return window.__VOONTO__;
	  },
	
	
	  ready: function () {
	    var allP;
	    var app = window.__VOONTO__;
	
	    allP = [];
	    allP.push(_deployRequireJS());
	    allP.push(_domReadyP());
	    allP.push(window.__VOONTO__.createGlobal(_constants.NAMESPACE));
	
	    return RSVP.all(allP).then(function () {
	      return app.require = window.requirejs;
	    }).then(function () {
	      return app.define = window.define;
	    }).then(function () {
	      return window.define = undefined;
	    }).then(function () {
	      return app;
	    });
	  }()
	});
	
	exports.default = Voonto;
	
	/* Private */
	
	function _deployRequireJS() {
	  return new RSVP.Promise(function (resolve, reject) {
	    var script;
	
	    script = document.createElement('script');
	    script.src = _constants.REQUIREJS_URL;
	    script.async = true;
	    script.onload = function () {
	      return resolve(window.requirejs);
	    };
	    script.onerror = reject;
	
	    document.body.appendChild(script);
	  });
	}
	
	function _domReadyP() {
	  return new RSVP.Promise(function (resolve, reject) {
	    $(document).ready(resolve);
	    setTimeout(reject, _constants.REJECT_TIMEOUT); // FIXME: cancel timer when resolved
	  });
	}

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// voonto.js